var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { offerList as api } from '../../api';
import { useOfferListColumns } from '../../hooks/useColumns';
import MaterialTable from '../MaterialTable';
import PageLayout from '../atoms/PageLayout';
import DownloadSampleOrdersCSVButton from '../organisms/DownloadSampleOrdersCSVButton';
import useFetch from '../../hooks/useFetch';
import { decamelize } from '../../utils/camelize';
var AdminSampleOrderedOfferListsPage = function () {
    var t = useTranslation().t;
    var OfferListColumns = useOfferListColumns();
    var query = qs.parse(location.search.slice(1));
    var defaultFilter = React.useCallback(function (field) {
        var filters = query.filters || {};
        return filters[field];
    }, [query]);
    var columns = React.useMemo(function () { return [
        OfferListColumns.producerCountry,
        __assign(__assign({}, OfferListColumns.producerName), { field: 'producer', defaultFilter: defaultFilter('producer'), filtering: true }),
        __assign(__assign({}, OfferListColumns.name), { defaultFilter: defaultFilter('name') }),
        __assign(__assign({}, OfferListColumns.paymentTerm), { defaultFilter: defaultFilter('paymentTerm') }),
        __assign(__assign({}, OfferListColumns.officeNames), { defaultFilter: defaultFilter('officeNames') }),
        __assign(__assign({}, OfferListColumns.status), { defaultFilter: defaultFilter('status') }),
        __assign(__assign({}, OfferListColumns.officeDetailsSampleOrderStartedAt), { filtering: false }),
        __assign(__assign({}, OfferListColumns.officeDetailsSampleOrderExpiredAt), { filtering: false }),
        __assign(__assign({}, OfferListColumns.sampleOrdersCount), { filtering: false }),
        OfferListColumns.orderAction,
    ]; }, [OfferListColumns, defaultFilter]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'producer':
                    q.producer_firstname_or_producer_lastname_cont = filter.value;
                    break;
                case 'status':
                    q.with_status = filter.value;
                    break;
                case 'officeNames':
                    q.office_details_office_id_in = filter.value;
                    break;
                case 'paymentTerm':
                    q.with_payment_term = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var fetchOfferLists = useFetch({
        buildFilterParams: buildFilterParams,
        api: api.getAllWithSampleOrderSummary,
    });
    return (React.createElement(PageLayout, { title: t('pages.sampleOrderedOfferLists.title'), actions: React.createElement(DownloadSampleOrdersCSVButton, { type: "SampleOrder::DirectSampleOrder" }) },
        React.createElement(MaterialTable, { model: "offerList", sortSaveKey: "adminOrderedOfferLists", columns: columns, data: fetchOfferLists, detailPath: function (sampleOrder) {
                return "/admin/offer_lists/".concat(sampleOrder.id, "/sample_orders");
            }, options: {
                paging: true,
                filtering: true,
                sorting: false,
            } })));
};
export default AdminSampleOrderedOfferListsPage;
